export const TrainerIcon = () => (
  <svg width='56' height='56' viewBox='0 0 56 56' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_190_5278)'>
      <path
        d='M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z'
        fill='#4F66D0'
      />
      <path
        d='M40.8257 7.43896L10.8081 45.215L14.3828 48.7896L13.953 49.1941L19.4197 54.6609C22.1237 55.5305 25.0069 56 27.9999 56C43.4639 56 55.9999 43.464 55.9999 28C55.9999 25.9263 55.7745 23.9053 55.3467 21.9599L40.8257 7.43896Z'
        fill='#2740B0'
      />
      <path d='M13.9531 10.584H43.9708V49.1943H13.9531V10.584Z' fill='#EAEAEA' />
      <path d='M26.1899 10.584H43.9707V49.1943H26.1899V10.584Z' fill='#D1D1D1' />
      <path d='M10.8081 7.43896H40.8257V45.215H10.8081V7.43896Z' fill='white' />
      <path d='M26.1899 7.43896H40.8258V45.215H26.1899V7.43896Z' fill='#EAEAEA' />
      <path
        d='M19.4607 22.8961C16.5779 22.8961 14.2417 20.5588 14.2417 17.6771C14.2417 14.7943 16.5781 12.458 19.4607 12.458L22.0703 16.6785L19.4607 22.8961Z'
        fill='#545454'
      />
      <path
        d='M23.1518 13.9862L19.4609 17.6771V12.458C20.9024 12.458 22.2073 13.0419 23.1518 13.9862Z'
        fill='#A9E54A'
      />
      <path
        d='M24.68 17.6774C24.68 20.5591 22.3437 22.8965 19.4609 22.8965V17.6774L22.3094 13.3027C22.6135 13.5007 22.8952 13.73 23.1518 13.9865C24.0962 14.931 24.68 16.2361 24.68 17.6774Z'
        fill='#FF5555'
      />
      <path d='M29.6987 12.7554H37.317V16.0366H29.6987V12.7554Z' fill='#545454' />
      <path d='M29.6987 19.3179H37.317V22.5991H29.6987V19.3179Z' fill='#545454' />
      <path d='M14.2417 27.1885H21.86V30.4697H14.2417V27.1885Z' fill='#545454' />
      <path d='M14.2417 33.751H21.86V37.0322H14.2417V33.751Z' fill='#545454' />
      <path d='M26.1899 27.1885H37.3171V39.6032H26.1899V27.1885Z' fill='#ED9507' />
    </g>
    <defs>
      <clipPath id='clip0_190_5278'>
        <rect width='56' height='56' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
